/* tslint:disable */
import { Component, OnInit } from '@angular/core';
import { AuthService } from './auth.service';
import { Usuario } from './usuario';
import { Http } from "@angular/http";
import { Headers, RequestOptions } from "@angular/http";


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  lottieConfig: any;
  login:any;
  usuario: Usuario = new Usuario();
  urlToJson = 'assets/passwd.json';
  logo = 'assets/img/logo.png';
  constructor(private authService: AuthService, public http: Http) {
   }

  ngOnInit() {
//    this.http.get(this.urlToJson).subscribe(response => {
 //     console.log (response);
 //   });
    
  }

  onSubmit(formulario){
    this.authService.fazerLogin(formulario.value);
  }

}



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/login/login.component.ts